/* DailyEnoch - Adv modulable (ak-adv.js)
   Tout passe par la delegation d'evenements : fonctionne meme quand
   l'editeur de theme re-rend une section. */
(function () {
  if (window.__akAdv) return;
  window.__akAdv = true;

  /* ---------- Carrousel d'avis ---------- */
  function rvImgs(t) { return t.querySelectorAll('img'); }

  function rvGo(t, n) {
    var im = rvImgs(t)[n];
    if (im) t.scrollTo({ left: im.offsetLeft - t.offsetLeft, behavior: 'smooth' });
  }

  function rvSync(t) {
    var d = t.parentNode.querySelector('.ak-rv-d');
    if (!d) return;
    var p = t.scrollLeft, n = 0, best = 1e9;
    rvImgs(t).forEach(function (x, k) {
      var v = Math.abs(x.offsetLeft - t.offsetLeft - p);
      if (v < best) { best = v; n = k; }
    });
    d.querySelectorAll('i').forEach(function (x, k) { x.classList.toggle('on', k === n); });
  }

  var rvTimer;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('ak-rv-t')) return;
    clearTimeout(rvTimer);
    rvTimer = setTimeout(function () { rvSync(t); }, 90);
  }, true);

  /* ---------- Ajout au panier ---------- */
  var busy = false;

  function variantOf(btn, form) {
    var inp = form ? form.querySelector('[name=id]') : document.querySelector('.ak-form [name=id]');
    return (btn && btn.getAttribute('data-variant')) || (inp && inp.value) || '';
  }

  function afterMode() {
    var el = document.querySelector('[data-ak-after]');
    return (el && el.getAttribute('data-ak-after')) || 'drawer';
  }

  function routes() {
    return (window.Theme && window.Theme.routes) || window.routes || {};
  }

  function cartUrl() { return routes().cart_url || '/cart'; }

  function addUrl() {
    var u = routes().cart_add_url || '/cart/add';
    return /\.js$/.test(u) ? u : u + '.js';
  }

  function openDrawer() {
    if (typeof window.SLIDECART_OPEN === 'function') {
      try { window.SLIDECART_OPEN(); return true; } catch (e) {}
    }
    var A = window.Shopify && window.Shopify.actions;
    if (A && A.openCart) { A.openCart(); return true; }
    var d = document.querySelector('theme-drawer#cart-drawer, cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }

  function addToCart(btn, form) {
    if (busy) return;
    var id = variantOf(btn, form);
    if (!id) {
      var o = document.getElementById('offer');
      if (o) o.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    busy = true;
    var original = btn ? btn.innerHTML : '';
    if (btn) btn.textContent = btn.getAttribute('data-adding') || 'Adding…';

    function reset(delay) {
      setTimeout(function () { if (btn) btn.innerHTML = original; busy = false; }, delay || 0);
    }

    function done() {
      var mode = afterMode();
      if (mode === 'checkout') { window.location.href = '/checkout'; return; }
      if (mode === 'cart') { window.location.href = cartUrl(); return; }
      if (btn) btn.textContent = btn.getAttribute('data-added') || '✓ Added';
      if (!openDrawer()) { window.location.href = cartUrl(); return; }
      reset(1400);
    }

    function fail() { reset(); window.location.href = cartUrl(); }

    var A = window.Shopify && window.Shopify.actions;
    var slideCart = typeof window.SLIDECART_OPEN === 'function';

    /* Sans app de panier : API officielle Horizon (rafraichit le tiroir du theme). */
    if (!slideCart && A && A.updateCart && afterMode() === 'drawer') {
      A.updateCart({ lines: [{ merchandiseId: String(id), quantity: 1 }] }, { event: { context: 'product' } })
        .then(function (res) {
          if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
          done();
        })
        .catch(fail);
      return;
    }

    /* Avec Slide Cart (ou autre theme) : ajout AJAX classique, l'app detecte l'ajout. */
    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'add failed'); return j; }); })
      .then(done)
      .catch(fail);
  }

  /* ---------- Barre collante ---------- */
  function tick() {
    var bar = document.querySelector('.ak-stk');
    if (!bar) return;
    var rows = document.querySelectorAll('.ak .ak-r');
    var n = parseInt(bar.getAttribute('data-after-reason') || '2', 10) || 1;
    var anchor = rows.length ? rows[Math.min(n, rows.length) - 1] : document.querySelector('.ak-hero');
    var offer = document.getElementById('offer');
    var a = anchor ? anchor.getBoundingClientRect().top < 0 : window.scrollY > 600;
    var b = false;
    if (offer) {
      var r = offer.getBoundingClientRect();
      b = r.top < window.innerHeight && r.bottom > 0;
    }
    bar.classList.toggle('on', a && !b);
  }

  /* ---------- Date du jour automatique ---------- */
  function ord(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) { case 1: return 'st'; case 2: return 'nd'; case 3: return 'rd'; default: return 'th'; }
  }

  function dates() {
    var now = new Date();
    var lang = document.documentElement.lang || 'en';
    var s;
    if (lang.slice(0, 2) === 'en') {
      s = now.toLocaleDateString('en-US', { weekday: 'short' }) + '. ' +
        now.toLocaleDateString('en-US', { month: 'long' }) + ' ' +
        now.getDate() + ord(now.getDate()) + ', ' + now.getFullYear();
    } else {
      s = now.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' });
    }
    document.querySelectorAll('[data-ak-date]').forEach(function (el) {
      var icon = el.getAttribute('data-icon') || '';
      var time = el.getAttribute('data-time') || '';
      el.textContent = (icon ? icon + ' ' : '') + s + (time ? '  |  ' + time : '');
    });
  }

  /* ---------- Branchements ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var dot = t.closest('.ak-rv-d i');
    if (dot) {
      var d = dot.parentNode;
      var track = d.parentNode.querySelector('.ak-rv-t');
      if (track) rvGo(track, Array.prototype.indexOf.call(d.children, dot));
      return;
    }
    var add = t.closest('[data-ak-add]');
    if (add) { e.preventDefault(); addToCart(add); }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.ak-form');
    if (!f) return;
    e.preventDefault();
    addToCart(f.querySelector('[type=submit]'), f);
  });

  function init() {
    dates();
    tick();
    document.querySelectorAll('.ak-rv-t').forEach(rvSync);
  }

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
